// removed by extract-text-webpack-plugin
module.exports = {"image":"image__3RSTf","lists":"lists__2Wc6D","popupImage":"popupImage__docR5"};


//////////////////
// WEBPACK FOOTER
// ./components/documentFolder/style.scss
// module id = Rf02
// module chunks = 1